import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ReportCard from '../../../../components/ReportCard';
import StyledNotesContainer from '../StyledNotesContainer';
import ReportNote from '../../../../components/ReportNote';

const DeliveryNotes = ({ isLhb, pitcherId, levelId }) => {
    const { t: translate } = useTranslation();

    const [hasAttackPlanNote, setHasAttackPlanNote] = useState(true);

    return hasAttackPlanNote ? (
        <Row>
            <Col md={12}>
                <ReportCard title={translate('pitcher-overview.sections.attack-plan')}>
                    <StyledNotesContainer>
                        { pitcherId && hasAttackPlanNote && (
                            <ReportNote
                                type={levelId === 8 ? 'oppp' : 'mnhp'}
                                section={isLhb ? 242 : 241}
                                playerId={pitcherId}
                                levelId={levelId}
                                hasDataCallback={setHasAttackPlanNote}
                            />
                        ) }
                    </StyledNotesContainer>
                </ReportCard>
            </Col>
        </Row>
    ) : <></>;
};

export default DeliveryNotes;
